/* istanbul ignore next */
export var reducer1 = function () { };
//# sourceMappingURL=reducer1.js.map